"use client";

import * as React from "react";

import { FUNDING_ELIGIBILITY_BORDER_CROSSFADE } from "@/components/home/funding-eligibility-shared";
import { cn } from "@/lib/utils";

/** Inner radius when the outer shell draws a 1px border ring (rounded-2xl = 1rem). */
export const FUNDING_ELIGIBILITY_CARD_INNER_RADIUS = "rounded-[calc(1rem-1px)]";

/** True gradient border via padding-box/border-box masking (not a bg fill). */
export const FUNDING_ELIGIBILITY_GRADIENT_BORDER_CLASS =
  "border border-transparent [background-image:linear-gradient(var(--grey-50),var(--grey-50)),var(--gradient-secondary)] [background-clip:padding-box,border-box] [background-origin:border-box]";

interface FundingEligibilityStepCardProps {
  showGradient: boolean;
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
}

export function FundingEligibilityStepCard({
  showGradient,
  className,
  contentClassName,
  children,
}: FundingEligibilityStepCardProps) {
  return (
    <div
      className={cn(
        "relative flex flex-1 flex-col self-stretch overflow-visible rounded-2xl p-px",
        className
      )}
    >
      <div
        aria-hidden
        className={cn(
          "border-grey-100 pointer-events-none absolute inset-0 rounded-2xl border",
          FUNDING_ELIGIBILITY_BORDER_CROSSFADE,
          showGradient ? "opacity-0" : "opacity-100"
        )}
      />
      <div
        aria-hidden
        className={cn(
          "pointer-events-none absolute inset-0 rounded-2xl",
          FUNDING_ELIGIBILITY_GRADIENT_BORDER_CLASS,
          FUNDING_ELIGIBILITY_BORDER_CROSSFADE,
          showGradient ? "opacity-100" : "opacity-0"
        )}
      />
      <div
        className={cn(
          "bg-grey-50 @container relative z-10 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden",
          FUNDING_ELIGIBILITY_CARD_INNER_RADIUS,
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
